import React, {Component} from 'react';
import Accordion from 'react-bootstrap/Accordion';
import 'assets/sass/dashboard/my-activity/Item.scss';
import {MoneyField} from "buenLib/components/MoneyField";
import {ActivityIcon} from "./ActivityIcon";

export class ActivityItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
        this.collapseToggle = this.collapseToggle.bind(this)
    }

    collapseToggle() {
        if (!this.state.isOpen) {
            this.setState({
                isOpen: true,
            })
        } else {
            this.setState({
                isOpen: false,
            })
        }
    }

    activity() {
        return this.props.activity
    }

    renderDate(dateString) {
        if (dateString) {
            return new Date(dateString).toLocaleDateString("es");
        } else {
            return "-"
        }
    }

    render() {
        return (
            <div className={'my-activity-item' + (this.state.isOpen ? ' open' : '')}>
                <Accordion>
                    <Accordion.Toggle as="div" variant="link" eventKey="1" onClick={this.collapseToggle}>
                        <div className="my-activity-header">
                            <div className="header-item">
                                <ActivityIcon activity={this.activity()}/>
                                <div className="title">
                                    <h5>{this.activity().title()}</h5>
                                    <div className="subtitle">{this.activity().subtitle()}</div>
                                </div>
                            </div>
                            <div className="header-data">
                                <div className="volume"><MoneyField value={this.activity().volume()}
                                                                    currency={this.activity().volumeCurrency()}
                                                                    prefix={this.activity().prettyVolumeCurrency() + " "}/>
                                </div>
                                <div className="date">{this.renderDate(this.activity().date())}</div>
                            </div>
                            <div className="header-arrow"></div>
                        </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1">
                        <div className="my-activity-content">
                            {this.props.children}
                        </div>
                    </Accordion.Collapse>
                </Accordion>
            </div>
        );
    }
}
